import { Box, Button } from '@machobear/design-system'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { colors } from '@/styles'

const MobileFooterButtonWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${colors.white};
  border-top: 1px solid ${colors.mediumLightGrey};
  border-bottom: 1px solid ${colors.mediumLightGrey};
  z-index: 100;

  ${props =>
    props.displayBlock &&
    `
  display: block;
  position: static;
`}
`

export const MobileButton = ({ handleStartScreening }: { handleStartScreening: () => void }) => {
  const { t } = useTranslation()

  return (
    <MobileFooterButtonWrapper>
      <Box padding="xsmall">
        <Button onClick={handleStartScreening} size="small">
          {t('l.standalone_trustscore.list.start_screening.text', 'Start Screening')}
        </Button>
      </Box>
    </MobileFooterButtonWrapper>
  )
}
